import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-add-to-group',
	templateUrl: './add-to-group.component.html',
	styleUrls: ['./add-to-group.component.scss'],
})
export class AddToGroupComponent {
	moveToGroupForm: FormGroup = new FormGroup({
		projectGroupId: new FormControl('', [Validators.required]),
	});

	constructor(
		public dialogRef: MatDialogRef<AddToGroupComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: any
	) {
		this.moveToGroupForm.get('projectGroupId').setValue(this.dialogData.projectGroups[0].id);
	}

	submitForm() {
		this.closeDialog(this.moveToGroupForm.value);
	}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
